import React from 'react';
import {Facebook, Instagram, Linkedin} from 'lucide-react';
import {useLanguageStore} from "../store/languageStore";
import axios from "axios";
import {api} from "../api/api";
import {Link} from "react-router-dom";

export default function Footer() {
    const [loadSupmit, setLoadSubmit] = React.useState(false);
    const {language} = useLanguageStore();
    const isArabic = language === 'ar';

    const content = {
        about: {
            title: isArabic ? "عن الشركة" : "About",
            description: isArabic ? "جدار هي شركة رائدة في مجال المواد الكيميائية للبناء وقطاع المقاولات، توفر حلولاً شاملة تشمل مواد لصق البلاط، العزل المائي، إصلاح الخرسانة، التشطيبات المتقدمة، وخدمات التنفيذ. منذ عام 2008، استخدمنا تقنيات متطورة مثل النانو-جل لضمان جودة فائقة، متانة، وأداء فعال، تلبي أعلى المعايير العالمية." : "Jidar is a leader in construction chemicals and contracting sector, providing comprehensive solutions including tile adhesives, waterproofing, concrete repair, advanced finishing, and execution services. Since 2008, we have utilized cutting-edge technologies like Nano-Gel to ensure superior quality, durability, and efficient performance, meeting the highest global standards"
        }, navigation: {
            services: isArabic ? "الخدمات" : "Services",
            products: isArabic ? "المنتجات" : "Products",
            solutions: isArabic ? "الحلول" : "Solutions",
            aboutUs: isArabic ? "من نحن" : "About Us",
            documents: isArabic ? "الوثائق" : "Documents"
        }, contact: {
            title: isArabic ? "اتصل بنا" : "Contact", email: "info@jidarcompany.com"
        }, visitUs: {
            title: isArabic ? "زورونا" : "Visit Us",
            address: isArabic ? "العراق، بغداد، الكرادة" : "Iraq, Baghdad, Karrada"
        }, form: {
            title: isArabic ? "لديك سؤال؟ اتصل بنا!" : "Have a question? Contact us!",
            name: isArabic ? "الاسم" : "Name",
            namePlaceholder: isArabic ? "أدخل اسمك" : "Enter your name",
            email: isArabic ? "البريد الإلكتروني" : "Email",
            emailPlaceholder: isArabic ? "أدخل عنوان بريدك الإلكتروني" : "Enter your email address",
            phone: isArabic ? "رقم الموبايل" : "Phone",
            phonePlaceholder: isArabic ? "أدخل رقم الموبايل" : "Enter your phone number",
            message: isArabic ? "رسالتك" : "Your Message",
            messagePlaceholder: isArabic ? "اكتب رسالتك هنا..." : "Write your message here...",
            sendButton: isArabic ? "إرسال الرسالة" : "Send Message"
        }, copyright: isArabic ? "حقوق النشر © 2025 شركة جدار" : "Copyright © 2025 Jidar Company"
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoadSubmit(true)


        const form = {
            "name": e.target?.name?.value || '',
            "email": e.target?.email?.value || '',
            "phone": e.target?.phone?.value || '',
            "subject": "string",
            "message": e.target?.message?.value || ''
        }
        console.log(form);




        api.post('/contact/', form).then((res) => {
            setLoadSubmit(false)
            console.log(res);
            e.target.reset()

        }).catch((err) => {
            setLoadSubmit(false)
            console.log(err);
            e.target.reset()

        })


    }


    return (<footer className="bg-[#14261C] text-white py-16" dir={isArabic ? "rtl" : "ltr"}>
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {/* About Section */}
                    <div className="space-y-6">
                        <h2 className="text-2xl font-semibold text-teal-400">{content.about.title}</h2>
                        <p className="text-gray-300 leading-relaxed">
                            {content.about.description}
                        </p>
                    </div>

                    {/* Navigation & Contact Sections */}
                    <div className="space-y-10">
                        {/* Navigation Links */}
                        <div>
                            <ul className="space-y-3">
                                <li><Link to="/#services"
                                       className="hover:text-teal-400 transition-colors">{content.navigation.services}</Link>
                                </li>
                                <li><Link to="/products"
                                       className="hover:text-teal-400 transition-colors">{content.navigation.products}</Link>
                                </li>
                                <li><Link to="/solutions"
                                       className="hover:text-teal-400 transition-colors">{content.navigation.solutions}</Link>
                                </li>
                                <li><Link to="/about"
                                       className="hover:text-teal-400 transition-colors">{content.navigation.aboutUs}</Link>
                                </li>
                                <li><Link to="/documents"
                                       className="hover:text-teal-400 transition-colors">{content.navigation.documents}</Link>
                                </li>
                            </ul>
                        </div>

                        {/* Contact Information */}
                        <div className="space-y-6">
                            <h2 className="text-2xl font-semibold text-teal-400">{content.contact.title}</h2>
                            <div className="space-y-3 " >
                                <a href="tel:+9647800106888" className="text-gray-300" dir={'ltr'}>+964 780-010-6888</a>
                                <br/>
                                <a href="tel:+9647869294936" className="text-gray-300" dir={'ltr'}>+964 786-929-4936</a>
                                <br/>
                                <a href="mailto:info@jidarcompany.com"
                                   className="text-gray-300">info@jidarcompany.com</a>
                            </div>

                            {/* Social Media Icons */}
                            <div className="flex space-x-4">
                                <a href="https://www.facebook.com/share/1DPE21dUE5/" className="text-gray-300 hover:text-teal-400 transition-colors">
                                    <Facebook size={20}/>
                                </a>
                                <a href="https://www.instagram.com/jidar_company" className="text-gray-300 hover:text-teal-400 transition-colors">
                                    <Instagram size={20}/>
                                </a>
                                <a href="https://www.linkedin.com/company/jidar-construction-chemical/" className="text-gray-300 hover:text-teal-400 transition-colors">
                                    <Linkedin size={20}/>
                                </a>
                            </div>
                        </div>

                        {/* Visit Us Section */}
                        <div className="space-y-2">
                            <h2 className="text-2xl font-semibold text-teal-400">{content.visitUs.title}</h2>
                            <p className="text-gray-300">{content.visitUs.address}</p>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="space-y-6">
                        <h2 className="text-2xl font-semibold text-teal-400">{content.form.title}</h2>
                        <form className="space-y-4" onSubmit={handleSubmit} >
                            <div>
                                <label htmlFor="name" className="block text-gray-300 mb-2">{content.form.name}</label>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder={content.form.namePlaceholder}
                                    required
                                    className="w-full px-4 py-3 rounded-md bg-transparent border border-gray-700 focus:border-teal-400 focus:outline-none text-white"
                                />
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-gray-300 mb-2">{content.form.email}</label>
                                <input
                                    type="email"
                                    id="email"
                                    required
                                    placeholder={content.form.emailPlaceholder}
                                    className="w-full px-4 py-3 rounded-md bg-transparent border border-gray-700 focus:border-teal-400 focus:outline-none text-white"
                                />
                            </div>
                            <div>
                                <label htmlFor="phone" className="block text-gray-300 mb-2">{content.form.phone}</label>
                                <input
                                    type="phone"
                                    id="phone"
                                    required
                                    placeholder={content.form.phonePlaceholder}
                                    className="w-full px-4 py-3 rounded-md bg-transparent border border-gray-700 focus:border-teal-400 focus:outline-none text-white"
                                />
                            </div>
                            <div>
                                <label htmlFor="message"
                                       className="block text-gray-300 mb-2">{content.form.message}</label>
                                <textarea
                                    id="message"
                                    rows="4"
                                    required
                                    placeholder={content.form.messagePlaceholder}
                                    className="w-full px-4 py-3 rounded-md bg-transparent border border-gray-700 focus:border-teal-400 focus:outline-none text-white"
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className={!loadSupmit ? "w-full bg-teal-400 hover:bg-teal-500 text-white font-medium py-3 px-4 rounded-md transition-colors" : "w-full bg-gray-300 hover:bg-gray-400 text-white font-medium py-3 px-4 rounded-md transition-colors" }
                                disabled={loadSupmit}
                            >
                                {content.form.sendButton}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-16 pt-8 border-t border-gray-800">
                    <p className="text-gray-400 text-center md:text-left">{content.copyright}</p>
                </div>
            </div>
        </footer>);
}